import { ItemKind } from '../../../constants/ItemKind';
import { MediaType } from '../../../constants/MediaType';
export function toFolder(data) {
  return {
    id: data.id,
    name: data.title._content,
    kind: ItemKind.Folder,
    source: 'flickr',
    mediaType: MediaType.Picture,
    thumbnailUrl: data.primary_photo_extras.url_m || data.primary_photo_extras.url_s || data.primary_photo_extras.url_t,
    parentId: null,
    filesCount: Number(data.photos) + Number(data.videos),
    createdAt: Number(data.date_create) * 1000
  };
}